import React from "react";
import styled from "styled-components";
import { AiFillLinkedin, AiOutlineMail } from "react-icons/ai";
import { GoMarkGithub } from "react-icons/go";
import { FiServer, FiMonitor, FiRss, FiMoon } from "react-icons/fi";
import Button from "../Button/Button";
import { Link } from "react-scroll";
import ProfileImage from "../../assets/images/profile/profileImage1.jpg";

function Landing() {
  return (
    <Container id="home">
      <section className="landing">
        <div className="landing-container main-container">
          <div className="socials">
            <a
              href="https://github.com/willcordeiro"
              target="blank"
              name="github"
            >
              <GoMarkGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/william-cords/"
              target="blank"
              name="linkedin"
            >
              <AiFillLinkedin />
            </a>
            <a
              href="mailto:willcordeiro800@gmail.com?subject=Hello%20again"
              target="blank"
              name="mail"
            >
              <AiOutlineMail />
            </a>
          </div>
          <div className="info">
            <h1>Fullstack Developer</h1>
            <h3>Hello, I'm William Cordeiro</h3>
            <p>
              Experienced Full Stack software engineer with a passion for
              creating high-quality web pages and applications that have worked
              in many different projects around the world.
            </p>
            <Link to="contact" smooth={true}>
              <Button children={" Let's Talk!"} />
            </Link>
          </div>
          <div className="profile-area">
            <div className="outer-circle">
              <span>
                <FiServer />
              </span>
              <span>
                <FiMonitor />
              </span>
              <span>
                <FiRss />
              </span>
              <span>
                <FiMoon />
              </span>
            </div>
            <div className="inner-circle">
              <img src={ProfileImage} alt="" className="inner-image" />
            </div>
          </div>
        </div>
      </section>
    </Container>
  );
}

export default Landing;

const Container = styled.div`
  section.landing .socials {
    display: flex;
    flex-direction: column;
    gap: 1.6;
    margin-top: 5rem;
  }

  section.landing .socials a {
    font-size: 2.5rem;
    background: var(--color-light);
    color: var(--color-dark);
    padding: 0.3rem;
    border-radius: 50%;
    height: 2rem;
    margin: 0 0 20px;
    width: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  section.landing .socials a:hover {
    animation: pulse2 0.3s 2;
  }

  section.landing .socials a:hover {
    background: var(--color-primary);
    color: var(--color-white);
  }

  section.landing .info h1 {
    text-align: left;
  }

  section.landing h3 {
    margin: 2.4rem 0 1rem;
  }

  section.landing .info p {
    width: 90%;
    font-weight: bold;
    font-size: 1.2rem;
  }

  section.landing .profile-area {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  section.landing .profile-area .outer-circle {
    width: 28rem;
    height: 28rem;
    border: 1px solid var(--color-primary);
    border-radius: 50%;
    position: relative;
    animation: move 30s linear infinite;
  }

  @keyframes move {
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes pulse2 {
    0% {
      transform: scale(1);
    }
    35% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  section.landing .profile-area .outer-circle span {
    display: block;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    position: absolute;
    background: var(--color-white);
    color: var(--color-black);
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }

  section.landing .profile-area .outer-circle span:hover {
    color: var(--color-primary);
  }

  section.landing .profile-area .outer-circle span:nth-child(1) {
    left: calc(50% - 2rem);
    top: -2rem;
  }

  section.landing .profile-area .outer-circle span:nth-child(2) {
    right: -2rem;
    top: calc(50% - 2rem);
  }

  section.landing .profile-area .outer-circle span:nth-child(3) {
    left: -2rem;
    top: calc(50% - 2rem);
  }

  section.landing .profile-area .outer-circle span:nth-child(4) {
    bottom: -2rem;
    left: calc(50% - 2rem);
  }

  section.landing .profile-area .inner-circle {
    position: absolute;
    width: 20rem;
    height: 20rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }

  .inner-image {
    border-radius: 5%;
  }

  .inner-circle::after {
    content: "";
    background: var(--color-primary);
    mix-blend-mode: multiply;
    width: 20rem;
    height: 20rem;
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-100%, -100%);
    transition: transform 0.3s;
    transform-origin: left;
    z-index: -1;
    border-radius: 50%;
    pointer-events: none;
    opacity: 0.7;
  }

  .inner-circle:hover::after {
    transform: translate(0%);
    border-radius: 50%;
  }

  @media only screen and (min-width: 320px) {
    section.landing {
      padding-top: 6rem;
      padding-bottom: 0rem;
    }

    section.landing .landing-container {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(2, 1fr);
      grid-column-gap: 0px;
      grid-row-gap: 2rem;
      width: 90%;
    }

    section.landing .info p {
      width: 80%;
      display: grid;
      grid-template-columns: 1fr;
    }

    .info h1 {
      width: 80%;
      font-size: 3rem;
    }

    section.landing .main-container .socials {
      display: none;
    }

    section.landing .main-container .profile-area {
      grid-row: 1;
      width: 90%;
    }

    section.landing .profile-area .outer-circle {
      width: 26rem;
      height: 26rem;
    }
  }

  @media only screen and (min-width: 768px) {
    section.landing {
      padding-top: 6rem;
      padding-bottom: 0rem;
      margin-bottom: -25rem;
    }

    section.landing .landing-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 10px;
      grid-row-gap: 2rem;
      width: 100%;
    }

    section.landing .info p {
      width: 80%;
      display: grid;
      grid-template-columns: 0.5fr;
    }

    .info h1 {
      width: 80%;
      font-size: 3rem;
    }

    section.landing .main-container .socials {
      display: none;
    }

    section.landing .main-container .profile-area {
      grid-row: 1;
      width: 90%;
    }

    section.landing .profile-area .outer-circle {
      width: 32rem;
      height: 32rem;
    }
  }

  @media only screen and (min-width: 1200px) {
    section.landing .landing-container {
      display: grid;
      grid-template-columns: 10rem auto 28rem;
      gap: 2rem;
      width: 90%;
    }

    section.landing .info p {
      width: 90%;
    }

    .info h1 {
      width: 90%;
    }

    section.landing .main-container .profile-area {
      grid-row: auto;
      width: 90%;
    }

    section.landing .profile-area .outer-circle {
      width: 25rem;
      height: 25rem;
    }

    section.landing {
      padding-top: 15rem;
      position: relative;
      margin-bottom: 0rem;
    }

    section.landing .main-container .socials {
      display: block;
    }
  }
`;
